import { render } from "./AppTabs.vue?vue&type=template&id=31b0f54d&scoped=true&ts=true"
import script from "./AppTabs.vue?vue&type=script&lang=ts"
export * from "./AppTabs.vue?vue&type=script&lang=ts"

import "./AppTabs.vue?vue&type=style&index=0&id=31b0f54d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b0f54d"]])

export default __exports__